<template>
  <div>
    <ViewHeader :serial="$route.params.serial" @picker="pickerEventHandler" range="today"/>
    <div v-if="loading" class="row">
      <div class="col-12 align-self-center text-center">
        <LoadingAnimation/>
      </div>
    </div>
    <div v-else>
      <div v-if="noData" class="row">
        <div class="col-12 align-self-center text-center no-data">
          <h1>No data</h1>
          <h3 class="text-secondary"> {{ this.serial }}</h3>
          <p><i>Are you sure this device is connected to the CAN bus ?</i></p>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Fuel Used (L)</th>
                  <th scope="col">Odometer (KM)</th>
                  <th scope="col">Maintenance (KM)</th>
                  <th scope="col">Engine Hours</th>
                  <th scope="col">Engine Temperature (°C)</th>
                  <th scope="col">Fuel Level (%)</th>
                  <th scope="col">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="event in fmsEvents" :key="event.date">
                  <td>{{ event.fuel_used }}</td>
                  <td>{{ event.distance }}</td>
                  <td>{{ event.maintenance }}</td>
                  <td>{{ event.engine_hours }}</td>
                  <td>{{ event.engine_temperature }}</td>
                  <td>{{ event.fuel_level }}</td>
                  <td>{{ new Date(event.date).toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
import LoadingAnimation from '@/components/LoadingAnimation.vue'
import ViewHeader from '@/components/ViewHeader.vue'
import axios from '@/axios-auth.js'

export default {
  data () {
    return {
      loading: true,
      fmsEvents: [],
      serial: '',
      noData: false,
      from: null,
      to: null
    }
  },
  methods: {
    loadTachoEvents () {
      this.loading = true
      axios.get('/device/' + this.serial + '/fmsevents', {
        params: {
          from: this.from,
          to: this.to,
          max: 100
        }
      })
        .then((response) => {
          this.fmsEvents = response.data
          this.noData = false
        })
        .catch((e) => {
          if (!e.response) {
            if (e.code === 'ECONNABORTED') {
              EventBus.$emit('alert', 'error', 'Request timeout: The server took too long to respond.')
            } else {
              EventBus.$emit('alert', 'error', 'The server is unavailable. Please try again later.')
            }
          } else if (e.response.status === 401) {
            EventBus.$emit('alert', 'info', 'Your session has expired. Please login again.')
            this.$router.push({ name: 'login' })
          } else if (e.response.status === 404) {
            this.noData = true
          } else {
            EventBus.$emit('alert', 'error', 'A server error occured while loading the FMS events. Please try again later.')
            this.$router.push({ name: 'deviceSelection' })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    pickerEventHandler (from, to) {
      this.from = from
      this.to = to
      this.loadTachoEvents()
    }
  },
  mounted () {
    this.serial = this.$route.params.serial
    // emit the serial in case it was set by the user in the url
    EventBus.$emit('serial', this.serial)
  },
  components: {
    LoadingAnimation,
    ViewHeader
  }
}
</script>

<style scoped>
.no-data {
  margin-top: 20vh;
}
</style>
